var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalInstalled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 3.5,
    stroke: "#858F9E",
    strokeOpacity: 0.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.1095V25.5002C12 26.8815 13.12 28.0002 14.5 28.0002H37.5C38.88 28.0002 40 26.8802 40 25.5002V23.1095C40 22.1549 39.6585 21.2318 39.0373 20.5069L34.6573 15.3975C34.2818 14.9593 33.8159 14.6075 33.2917 14.3663C32.7674 14.1251 32.1971 14.0002 31.62 14.0002H20.38C19.8029 14.0002 19.2326 14.1251 18.7083 14.3663C18.1841 14.6075 17.7182 14.9593 17.3427 15.3975L12.9627 20.5069C12.3415 21.2318 12 22.1549 12 23.1095ZM20.38 16.0002C20.0914 16.0002 19.8063 16.0627 19.5442 16.1833C19.282 16.3039 19.0491 16.4798 18.8613 16.6989L15.1747 21.0002H19.3947C20.0532 21.0003 20.7015 21.1629 21.282 21.4736C21.8626 21.7844 22.3574 22.2336 22.7227 22.7815L22.9413 23.1095C23.124 23.3835 23.3714 23.6081 23.6617 23.7635C23.9519 23.9189 24.2761 24.0002 24.6053 24.0002H27.3947C27.7239 24.0002 28.0481 23.9189 28.3383 23.7635C28.6286 23.6081 28.876 23.3835 29.0587 23.1095L29.2773 22.7815C29.6426 22.2336 30.1374 21.7844 30.718 21.4736C31.2985 21.1629 31.9468 21.0003 32.6053 21.0002H36.8253L33.1387 16.6989C32.9509 16.4798 32.718 16.3039 32.4558 16.1833C32.1937 16.0627 31.9086 16.0002 31.62 16.0002H20.38Z",
    fill: "#843D94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7507 30.0002C12.784 30.0002 12 30.7842 12 31.7509V34.0002C12 35.0611 12.4214 36.0785 13.1716 36.8286C13.9217 37.5788 14.9391 38.0002 16 38.0002H36C37.0609 38.0002 38.0783 37.5788 38.8284 36.8286C39.5786 36.0785 40 35.0611 40 34.0002V31.7495C40 30.7842 39.216 30.0002 38.2493 30.0002H32.6053C31.9468 30.0003 31.2985 30.1629 30.718 30.4736C30.1374 30.7844 29.6426 31.2336 29.2773 31.7815L29.0587 32.1095C28.876 32.3835 28.6286 32.6081 28.3383 32.7635C28.0481 32.9189 27.7239 33.0002 27.3947 33.0002H24.6053C24.2761 33.0002 23.9519 32.9189 23.6617 32.7635C23.3714 32.6081 23.124 32.3835 22.9413 32.1095L22.7227 31.7815C22.3574 31.2336 21.8626 30.7844 21.282 30.4736C20.7015 30.1629 20.0532 30.0003 19.3947 30.0002H13.7507Z",
    fill: "#843D94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalInstalled);
export default __webpack_public_path__ + "static/media/TotalInstalled.7921aceab838a240abbb7ece305453da.svg";
export { ForwardRef as ReactComponent };